module.exports = __webpack_public_path__ + "img/40.5b750fea.jpg";